import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { MedicalSupplyType } from '../models/injection';

interface MedicalSupplyTypeSelectProps {
  value: number;
  onSupplyTypeChange: (value: number) => void;
  cssClass?: string;
  allowAny?: boolean;
  fullWidth?: boolean;
}

const MedicalSupplyTypeSelect = ({
  value,
  onSupplyTypeChange,
  cssClass,
  allowAny,
  fullWidth
}: MedicalSupplyTypeSelectProps) => {
  const { t } = useTranslation();

  const handleSupplyrChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const sypplyTypeValue = event.target.value as number;

    //callback
    onSupplyTypeChange && onSupplyTypeChange(sypplyTypeValue);
  };

  return (
    <FormControl variant={'outlined'} className={cssClass} size="small" fullWidth={fullWidth}>
      <InputLabel id="supplyLabel">{t('f-supplies-type')}</InputLabel>
      <Select
        label={t('f-supplies-type')}
        labelId="supplyLabel"
        id="supplySelect"
        value={value}
        onChange={handleSupplyrChange}
      >
        {allowAny && <MenuItem value={0}>{t('f-any')}</MenuItem>}
        <MenuItem value={MedicalSupplyType.Vaccination}>{t('f-supp-vaccination')}</MenuItem>

        <MenuItem value={MedicalSupplyType.Antibiotic}>{t('f-supp-antibiotic')}</MenuItem>

        <MenuItem value={MedicalSupplyType.Hormones}>{t('f-supp-hormones')}</MenuItem>

        <MenuItem value={MedicalSupplyType.Minerals}>{t('f-supp-minerals')}</MenuItem>

        <MenuItem value={MedicalSupplyType.Painkiller}>{t('f-supp-painkiller')}</MenuItem>

        <MenuItem value={MedicalSupplyType.Other}>{t('f-supp-other')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default MedicalSupplyTypeSelect;
